import React from 'react';
import FontAwesomeIcon from 'src/components/Icon';
import "./CalloutCard.scss";

interface CalloutCardProps {
  message: string | React.ReactNode;
  icon_type?: 'info' | 'warning' | 'alert';
  size?: 'default' | 'small';
  maxWidth?: string | number;
  maxHeight?: string | number;
  links?: {
    label: string;
    url: string;
  }[];
}

const CalloutCard: React.FC<CalloutCardProps> = ({
  message,
  links = [],
  icon_type,
  size = 'default',
  maxWidth,
  maxHeight
}) => {
  const getIcon = () => {
    switch (icon_type) {
      case 'info': return 'info-circle';
      case 'warning': return 'exclamation-triangle';
      case 'alert': return 'exclamation-circle';
      default: return null;
    }
  };

  const icon_glyph: any = getIcon();

  return (
    <div
      className={size === 'small' ? 'callout_card callout_card_small' : 'callout_card'}
      style={{
        maxWidth: maxWidth || 'none',
        maxHeight: maxHeight || 'none',
        overflow: maxHeight ? 'auto' : 'visible'
      }}
    >
      <div className="callout_card_content_wrapper">
        {icon_glyph && (
          <div className="callout_card_icon">
            <FontAwesomeIcon glyph={icon_glyph} weight="light" />
          </div>
        )}
        <div className="callout_card_text_area">
          <p className="callout_card_message">{message}</p>
          {links.length > 0 && (
            <div className="callout_card_actions">
              {links.map((link, index) => (
                <a
                  key={index}
                  href={link.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="callout_card_button"
                >
                  {link.label}
                </a>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CalloutCard;